<form [formGroup]="form" class="flex-col gap-6">
  <div class="flex-row gap-6 lg-flex-col">
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.title' | translate }}</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        formControlName="title"
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="2"
      [placeholder]="'activity.section.youtube.title.placeholder' | translate"></textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.subtitle' | translate }}</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        formControlName="subtitle"
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="2"
      [placeholder]="'activity.section.youtube.subtitle.placeholder' | translate"></textarea>
    </mat-form-field>
  </div>
  <div formArrayName="video">
    @for (control of videoFormArray?.controls; track control; let index = $index) {
      <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
        <mat-label>{{ 'activity.section.youtube.video.label' | translate }}</mat-label>
        <input type="text" [formControlName]="index" matInput>
        @if (!form.disabled) {
          <button matSuffix mat-icon-button [attr.aria-label]="'generic.remove' | translate" (click)="videoFormArray.removeAt(index);">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
</form>
